import {
  Card,
  Group,
  SimpleGrid,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import {
  IconChartBar,
  IconCloudUpload,
  IconDatabase,
  IconFileText,
  IconUsers,
  IconWorld,
} from "@tabler/icons-react";

const statistics = [
  {
    label: "Total Datasets",
    value: "12,847",
    description: "Open datasets available",
    icon: IconDatabase,
    color: "blue",
  },
  {
    label: "Active Users",
    value: "8,432",
    description: "Monthly active users",
    icon: IconUsers,
    color: "green",
  },
  {
    label: "Data Sources",
    value: "156",
    description: "Connected data providers",
    icon: IconWorld,
    color: "cyan",
  },
  {
    label: "Projects Created",
    value: "24,591",
    description: "Total projects this month",
    icon: IconChartBar,
    color: "violet",
  },
  {
    label: "Files Processed",
    value: "1.2M",
    description: "Files analyzed this year",
    icon: IconFileText,
    color: "orange",
  },
  {
    label: "Data Uploaded",
    value: "847 GB",
    description: "Total data processed",
    icon: IconCloudUpload,
    color: "pink",
  },
];

export function Statistics() {
  return (
    <Stack gap="xl">
      <Title order={2} fw={600} fz={28}>
        Platform Statistics
      </Title>
      <Text c="gray.9" fz={16} lh={1.6}>
        Key metrics and insights about the platform's growth and usage. See how
        the community is leveraging data to drive insights.
      </Text>
      <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
        {statistics.map((stat) => (
          <Card key={stat.label} p="lg" shadow="lg" radius="md">
            <Stack gap="sm">
              <Group gap="md" align="flex-start">
                <ThemeIcon
                  size={40}
                  radius="md"
                  color={stat.color}
                  variant="light"
                >
                  <stat.icon size={20} />
                </ThemeIcon>
                <Stack gap={2} flex={1}>
                  <Text fw={700} fz={24} c="dark.9">
                    {stat.value}
                  </Text>
                  <Text fw={600} fz={14} c="dark.7">
                    {stat.label}
                  </Text>
                  <Text size="xs" c="gray.9">
                    {stat.description}
                  </Text>
                </Stack>
              </Group>
            </Stack>
          </Card>
        ))}
      </SimpleGrid>
    </Stack>
  );
}
